import React from 'react';
import { FiStar } from 'react-icons/fi';

const TestimonialCard = ({ name, role, testimonial, rating, tierColor }) => {
  return (
    <div className="card p-6 border-t-4" style={{ borderTopColor: tierColor }}>
      <div className="flex items-center mb-4">
        {/* Star rating */}
        <div className="flex mr-2">
          {[...Array(rating)].map((_, i) => (
            <FiStar key={i} className="fill-current text-yellow-400" />
          ))}
        </div>
      </div>
      
      <p className="text-gray-700 mb-4 italic">"{testimonial}"</p>
      
      <div className="mt-4">
        <p className="font-medium">{name}</p>
        <p className="text-sm text-gray-600">{role}</p>
      </div>
    </div>
  );
};

export default TestimonialCard;